export default {
  data() {
    return {
      localizedGoalReasons: [
        {
          key: "Feel more relaxed",
          value: "message.goalReasonRelaxed"
        },
        {
          key: "more relaxed",
          value: "message.goalReasonRelaxedShort"
        },
        {
          key: "Feel more in control",
          value: "message.goalReasonControl"
        },
        {
          key: "more in control",
          value: "message.goalReasonControlShort"
        },
        {
          key: "More confidence",
          value: "message.goalReasonConfidence"
        },
        {
          key: "more confident",
          value: "message.goalReasonConfidenceShort"
        },
        {
          key: "Be more active",
          value: "message.goalReasonMoreActive"
        },
        {
          key: "more active",
          value: "message.goalReasonMoreActiveShort"
        },
        {
          key: "Feel healthier",
          value: "message.goalReasonHealthier"
        },
        {
          key: "healthier",
          value: "message.goalReasonHealthierShort"
        },
        {
          key: "Feel happier",
          value: "message.goalReasonHappier"
        },
        {
          key: "happier",
          value: "message.goalReasonHappierShort"
        }
      ]
    }
  },
  methods: {
    localizeGoalReason(key) {
      let self = this;
      let localizedGoalReason = self.localizedGoalReasons.filter(function (item) {
        return item.key === key;
      })[0];
      return self.$t(localizedGoalReason.value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/GoalReasons/index.js